export const login = ({ commit }) => {
    commit('login')
}

export const logout = ({ commit }) => {
    commit('logout')
}
